import React from "react";
import Chart from "react-apexcharts";

export default props => {
  const options = {
    title: {
      text: 'Session Revenue',
      align: 'left'
    },
    chart: {
      zoom: {
        enabled: false
      },
      animations: {
          enabled: true,
          easing: 'linear',
          dynamicAnimation: {
          speed: 1000
        }
      }
    },
    stroke: {
      curve: 'smooth'
    },
    tooltip: {
      x: {
        format: "yyyy/MM/dd HH:mm:ss.f"
      }
    },
    xaxis: {
      type: "datetime",
      range: props.range
    },
    yaxis: {
      labels: {
        formatter: val => val.toFixed(0)
      },
      title: { text: "Value" }
    }
  };
  return <Chart type="line" options={options} series={props.dataList}/>;
};
